import React, { createContext, useContext, useEffect, useReducer } from "react";
import apiCall from "../components/Api/api";
import { homeReducer } from "../reducers/homeReducer";

//Create context
export const HomeContext = createContext();

//Initial state
const initialState = {
  shareSafaris: [],
  safariPackages: [],
  featurePark: [],
  rareAnimals: [],
  posts:[],
  loading: true,
};

//Provider
const HomeProvider = ({ children }) => {
  const [homeState, homeDispatch] = useReducer(homeReducer, initialState);

  useEffect(() => {
    const fetchHome = async () => {
      homeDispatch({ type: "SET_LOADING", payload: true });
      try {
        // Or example of parallel requests using Promise.all
        const [
          shareSafariRes,
          packageRes,
          featureParkRes,
          rareAnimalRes,
          postsRes
        ] = await Promise.allSettled([
          apiCall({ url: `sharesafari?pageSize=3&page=1`, method: "GET" }),
          apiCall({ url: `package?pageSize=3&page=1&custom_sort_by=${Math.floor(Math.random() * 4) + 1}`, method: "GET" }),
          apiCall({ url: `featured-park?pageSize=12&page=1`, method: "GET" }),
          apiCall({ url: `rare-animal?pageSize=12&page=1`, method: "GET" }),
          apiCall({ url: `posts?pageSize=12&page=1`, method: "GET" })
        ]);
       
        if (shareSafariRes.status === "fulfilled" && shareSafariRes.value.status === 200) {
          const data = shareSafariRes.value.data?.share_safari?.data;
          homeDispatch({ type: "SET_HOME_SHARE_SAFARI", payload: data });
        } else {
          console.error("Sharesafari API failed:", shareSafariRes.reason);
        }

        if (packageRes.status === "fulfilled" && packageRes.value.status === 200) {
          const data = packageRes.value.data?.packages?.data;
          homeDispatch({ type: "SET_HOME_SAFARI_PACKAGES", payload: data.slice(0,3) });
        } else {
          console.error("Package API failed:", packageRes.reason);
        }
        if (featureParkRes.status === "fulfilled" && featureParkRes.value.status === 200) {
          const data = featureParkRes.value.data?.feature_park?.data;
          homeDispatch({ type: "SET_HOME_FEATURE_PARK", payload: data });
        } else {
          console.error("Package API failed:", featureParkRes.reason);
        }
        if (rareAnimalRes.status === "fulfilled" && rareAnimalRes.value.status === 200) {
          const data = rareAnimalRes.value.data?.rare_animal_exotic?.data;
          homeDispatch({ type: "SET_HOME_RARE_ANIMALS", payload: data });
        } else {
          console.error("Rare Animal API failed:", rareAnimalRes.reason);
        }

        if (postsRes.status === "fulfilled" && postsRes.value.status === 200) {
          const data = postsRes.value.data?.UserPosts?.data;
          homeDispatch({ type: "SET_HOME_USERS_POSTS", payload: data?.slice(0,3) });
        } else {
          console.error("Posts API failed:", postsRes.reason);
        }

      } catch (error) {

        console.error(error)
        homeDispatch({ type: "SET_LOADING", payload: false });
      }finally{
        homeDispatch({ type: "SET_LOADING", payload: false });
      }
    };

    // fetch all home data
    fetchHome();
  }, []);
  return (
    <HomeContext.Provider
      value={{
        ...homeState,
        homeDispatch,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

//hook
export const useHomeContext = () => useContext(HomeContext);

export default HomeProvider;
